import { Button, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import PropTypes from 'prop-types';
import TableHeader from '../../../../../theme/components/TableHeader/TableHeader';
import styles from '../Pendencias.style';
import { INITIAL_FILTER_STATE } from '../PendenciasTableConstants';

const useStyles = makeStyles(styles);

export const PendenciasParametrosHeader = props => {
  const { filters, setFilters } = props;
  const classes = useStyles(props);

  const clearFiltersDisabled = Object.values(filters).filter(fil => fil != null).length === 0;

  return (
    <TableHeader.Header>
      <TableHeader.Header.Title>
        <Typography>Busca & Filtros</Typography>
      </TableHeader.Header.Title>
      <TableHeader.OptionsLeft>
        <TableHeader.Input>
          <Button
            color="primary"
            className={classes.buttonClearFilter}
            disabled={clearFiltersDisabled}
            onClick={() => setFilters(INITIAL_FILTER_STATE)}
          >
            LIMPAR FILTROS
          </Button>
        </TableHeader.Input>
      </TableHeader.OptionsLeft>
    </TableHeader.Header>
  );
};

PendenciasParametrosHeader.propTypes = {
  filters: PropTypes.shape({
    parceiro: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
  setFilters: PropTypes.func.isRequired,
};
